export const NAMESPACE = "NewPortalWrapper";
export const SLIDER_FLYOVER_INSTANCE_ID = "sliderFlyoverInstanceId";
export const RESOURCES_CARD_TABS_INSTANCE_ID = "resourcesCardTabsInstanceId";
